export const GET_ACCESS_TO_LK_FNS_SERVICE_ID = 390;
export const GET_ACCESS_TO_LK_SERVICE_NAME = 'Подключение к Личному кабинету';
